import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import { useTranslation } from 'react-i18next';

const useChatName = (type: ChatRoomType): string => {
  const { t } = useTranslation();
  const data = {
    [ChatRoomType.System]: t('chatSystemMessages'),
    [ChatRoomType.CommunityManager]: t('chatCommunityManager'),
    [ChatRoomType.PersonalManager]: t('chatPersonalManager'),
    [ChatRoomType.Group]: t('investGroup'),
    [ChatRoomType.Private]: t('privateChat'),
  };

  return data[type] ?? '';
};

export default useChatName;
